import * as React from 'react';

import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import {
  DateField,
  EditButton,
  RecordContextProvider,
  TextField,
  useListContext,
  useTranslate,
} from 'react-admin';

import { IExchangeRate } from '../../types';

const MobileGrid = () => {
  const translate = useTranslate();
  const { data, isLoading } = useListContext<IExchangeRate>();

  if (isLoading || data.length === 0) {
    return null;
  }

  return (
    <Box margin="0.5em">
      {data.map((record) => (
        <RecordContextProvider key={record.id} value={record}>
          <Card sx={{ margin: '0.5rem 0' }}>
            <CardHeader
              title={`${translate('resources.rates.fields.name')} ${
                record.name
              }`}
              action={<EditButton />}
            />
            <CardContent sx={{ pt: 0 }}>
              <Typography variant="body2">
                {translate('resources.rates.fields.cashRate')}
                :&nbsp;
                <TextField source="cashRate" />
              </Typography>
              <Typography variant="body2">
                {translate('resources.rates.fields.cashlessRate')}
                :&nbsp;
                <TextField source="cashlessRate" />
              </Typography>
              <Typography variant="body2">
                {translate('resources.rates.fields.date')}
                :&nbsp;
                <DateField source="date" showTime />
              </Typography>
            </CardContent>
          </Card>
        </RecordContextProvider>
      ))}
    </Box>
  );
};

export default MobileGrid;
